import React from "react";
import { connect } from 'react-redux';
import { expenseTotal } from '../selectors/expenseTotal';
import { getVisibleExpenses } from '../selectors/expenses';
import numeral from 'numeral';
import CurrencyFormatter from 'currency-formatter-react'

export const ExpenseSummary = (props) => {

    const expenseWord = props.expenseCount === 1 ? 'expense' : 'expenses';

    return (
        <>
            <h2 className="expense-summary">
                Viewing <i>{props.expenseCount}</i> {expenseWord} totalling 
                {/* {numeral(props.expenseSum).format('$0,0.00')} */}
                &nbsp;
                <i>
                <CurrencyFormatter
                    value={Number(props.expenseSum).toFixed(2)}
                    currency='INR'
                    thousandSeparator={false}
                    isFloat={true}
                />
                </i>
            </h2>
        </>
    );
}

const mapStateToProps = (state) => {
    const visibleExpenses = getVisibleExpenses(state.expenses, state.filters);
    return {
        expenseSum: expenseTotal(visibleExpenses),
        expenseCount: visibleExpenses.length,
    }
}

export default connect(mapStateToProps)(ExpenseSummary);